import { getApiClient } from './apiClient'

export const apiClient = getApiClient(process.env.REACT_APP_WEAR_APP_ADMIN_API)

export const authorize = async () => {
  return apiClient.post('/authorise')
}

export const startServices = async () => {
  return apiClient.post('/start')
}

export const deleteServices = async () => {
  return apiClient.delete('/delete')
}
